export default __webpack_public_path__ + "static/media/icon-lowest-price.39c84e11.png";